
import { useCallback, useState } from 'react';
import { categorySyncService } from '@/services/categories/categorySyncService';
import { UserCategory } from '@/types';
import OfflineLogger from '@/utils/offlineLogger';

interface UseCategoriesSyncResult {
  syncCategories: () => Promise<UserCategory[]>;
  isSyncing: boolean;
  lastSyncTimestamp: number;
}

export const useCategoriesSync = (): UseCategoriesSyncResult => {
  const [isSyncing, setIsSyncing] = useState(false);
  const [lastSyncTimestamp, setLastSyncTimestamp] = useState(0);

  const syncCategories = useCallback(async (): Promise<UserCategory[]> => {
    setIsSyncing(true);
    try {
      //OfflineLogger.info('useCategoriesSync', 'Starting categories-only sync');
      
      const syncedCategories = await categorySyncService.performFullSync();
      setLastSyncTimestamp(Date.now());
      
      // Emetti evento specifico per la sincronizzazione delle categorie
      window.dispatchEvent(new CustomEvent('categoriesSyncCompleted', {
        detail: { categories: syncedCategories, timestamp: Date.now() }
      }));
      
      //OfflineLogger.info('useCategoriesSync', 'Categories sync completed successfully');
      return syncedCategories;
    } catch (error) {
      OfflineLogger.error('useCategoriesSync', error);
      throw error;
    } finally {
      setIsSyncing(false);
    }
  }, []);

  return {
    syncCategories,
    isSyncing,
    lastSyncTimestamp
  };
};
